import { render, staticRenderFns } from "./TabUsuarios.vue?vue&type=template&id=66ee6bd6&scoped=true&"
import script from "./TabUsuarios.vue?vue&type=script&lang=js&"
export * from "./TabUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ee6bd6",
  null
  
)

export default component.exports